import { State } from '../state';

export const pageUnavailable: State = {
    url: 'page-unavailable'
};
